import SelectLoader from "./classes/SelectLoader";
SelectLoader.setup();
import FormWizard from "./classes/FormWizard";
FormWizard.setup();